import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { EmployeeService } from '@core/services/employee/employee.service';
import { ProfileService } from '@core/services/profile/profile.service';
import { forkJoin, Observable } from 'rxjs';

@Injectable({
    providedIn: "root"
})
export class EmployeesResolver implements Resolve<any> {

    constructor(
        private _employeeService: EmployeeService,
        private _profileService: ProfileService
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        return forkJoin([
            this._employeeService.getEmployees({ page: 0, size: 10 }),
            this._profileService.getAll()
        ])
    }
}
